module.exports = __webpack_public_path__ + "img/weather07.65489d3a.png";